import { render, staticRenderFns } from "./LogCardWrapper.vue?vue&type=template&id=38643579&scoped=true"
import script from "./LogCardWrapper.vue?vue&type=script&lang=js"
export * from "./LogCardWrapper.vue?vue&type=script&lang=js"
import style0 from "./LogCardWrapper.vue?vue&type=style&index=0&id=38643579&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38643579",
  null
  
)

export default component.exports